import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import DocumentTitle from 'react-document-title'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'
import classnames from 'classnames'
import { isVoucher } from 'selectors/setupform'
import { loadSetupform, updateSetupformAdvancedDetails } from 'actions/setupform'
import SetupformBreadcrumbProgress, { BREADCRUMB_MORE_DETAILS } from 'components/setupform-breadcrumb-progress'
import ErrorMessage from 'components/error-message'
import { getPartnerUrl } from 'utils/urls'
import SetupformDetailsForm from 'components/setupform-details-form'

import styles from '../setupform-page/setupform-page.css'

import TimeOutLogo from '../../../assets/icons/to-logo-black.svg'
import ArrowRightIcon from '../../../assets/icons/arrow-right.svg'

export class SetupformDetailsPage extends Component {

  constructor(props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    this.props.loadSetupform(this.props.setupformId)
  }

  onSubmit(values) {
    return new Promise((resolve, reject) => {
      this.props.updateSetupformAdvancedDetails(this.props.setupformId, { ...values }, resolve, reject)
    })
  }

  handleSubmit() {
    this.setupformDetailsForm.submit()
  }

  render() {
    return (
      <DocumentTitle title={'Ecommerce Portal - Time Out - Setupform'}>
        <div styleName="page">

          <div styleName="header">
            <a href={getPartnerUrl(this.props.partnerId)}>
              <div styleName="logo">
                <TimeOutLogo styleName="logo-icon" />
              </div>
            </a>
            <SetupformBreadcrumbProgress
              isVoucher={this.props.isVoucher}
              currentStep={BREADCRUMB_MORE_DETAILS}
            />
            <button
              disabled={this.props.submitting}
              styleName={classnames('next', { 'next-submitting': this.props.submitting })}
              onClick={this.handleSubmit}
            >
              Next <ArrowRightIcon styleName="next-icon" />
            </button>
          </div>

          <ErrorMessage isFixed isSmall />

          <RelayoutWrapper>
            <Relayout align="center">
              <RelayoutItem sm="10">

                <SetupformDetailsForm
                  onSubmit={this.onSubmit}
                  ref={(c) => { this.setupformDetailsForm = c }}
                  setupformId={this.props.setupformId}
                />

              </RelayoutItem>
            </Relayout>
          </RelayoutWrapper>

        </div>
      </DocumentTitle>
    )
  }

}

SetupformDetailsPage.propTypes = {
  loadSetupform: PropTypes.func,
  partnerId: PropTypes.string,
  setupformId: PropTypes.string,
  isVoucher: PropTypes.bool,
  updateSetupformAdvancedDetails: PropTypes.func,
  submitting: PropTypes.bool,
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps.params,
  isVoucher: isVoucher(ownProps.params.setupformId)(state),
  submitting: state.form.setupform && state.form.setupform._submitting, // eslint-disable-line no-underscore-dangle
})

const mapDispatchToProps = { loadSetupform, updateSetupformAdvancedDetails }

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(SetupformDetailsPage, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/setupform-details-page/setupform-details-page.js
 **/